import { FULL_HD, HD } from './common.constants';

export const safetyMargins = {
  horizontal: {
    HD: 64,
    FULL_HD: 96,
  },
  vertical: {
    HD: 40,
    FULL_HD: 56,
  },
};

export const SIDENAV_WIDTH = {
  [HD]: 152,
  [FULL_HD]: 224,
};

export const SIDENAV_EXPANDED_WIDTH = {
  [HD]: 304,
  [FULL_HD]: 416,
};

export const LAYOUT_LEFT_PADDING = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const SCREEN_WIDTH = {
  [HD]: 1280,
  [FULL_HD]: 1920,
};

export const SCREEN_HEIGHT = {
  [HD]: 720,
  [FULL_HD]: 1080,
};

export const CONTENT_GAP = {
  [HD]: 12,
  [FULL_HD]: 12,
};
